import type { LocaleMessageBundle } from '../../types'

export const authChangePasswordMessages: LocaleMessageBundle = {
  vi: {
    'auth.changePassword.model': 'Mật khẩu',
    'auth.changePassword.title': 'Đổi mật khẩu',
    'auth.changePassword.subtitle': 'Cập nhật mật khẩu mới cho tài khoản',
    'auth.changePassword.fields.currentPassword': 'Mật khẩu hiện tại',
    'auth.changePassword.fields.newPassword': 'Mật khẩu mới',
    'auth.changePassword.fields.confirmPassword': 'Xác nhận mật khẩu',
    'auth.changePassword.actions.submit': 'Cập nhật mật khẩu',
    'auth.changePassword.actions.submitting': 'Đang cập nhật...',
    'auth.changePassword.actions.back': 'Quay lại',
    'auth.changePassword.feedback.success': 'Mật khẩu đã được cập nhật.',
    'auth.changePassword.feedback.failure': 'Đổi mật khẩu không thành công.',
    'auth.changePassword.validation.passwordMismatch': 'Mật khẩu xác nhận không khớp.',
    'auth.changePassword.errors.currentPasswordIncorrect': 'Mật khẩu hiện tại không đúng.',
  },
  en: {
    'auth.changePassword.model': 'Password',
    'auth.changePassword.title': 'Change password',
    'auth.changePassword.subtitle': 'Update the password for your account',
    'auth.changePassword.fields.currentPassword': 'Current password',
    'auth.changePassword.fields.newPassword': 'New password',
    'auth.changePassword.fields.confirmPassword': 'Confirm password',
    'auth.changePassword.actions.submit': 'Update password',
    'auth.changePassword.actions.submitting': 'Updating...',
    'auth.changePassword.actions.back': 'Back',
    'auth.changePassword.feedback.success': 'Password has been updated.',
    'auth.changePassword.feedback.failure': 'Failed to update password.',
    'auth.changePassword.validation.passwordMismatch': 'Password confirmation does not match.',
    'auth.changePassword.errors.currentPasswordIncorrect': 'Current password is incorrect.',
  },
}
